var DateUtils = {
    getDateSQLFormatted: function (date) {
        if (!date) return null;

        let dateString;
        if (date instanceof Date) {
            // Força formato brasileiro para evitar ambiguidade
            dateString = date.toLocaleString('pt-BR').replace(',', '');
        } else if (typeof date == "string") {
            dateString = date;
        } else {
            console.log("Invalid date");
            return date;
        }

        let dateAndTime = dateString.split(' ')
        let dateTokens = dateAndTime[0].split('/');
        let year = dateTokens[2];

        // Detecta o formato da data quando é string e há AM/PM
        // Se veio de Date.toLocaleString('pt-BR'), sempre será formato brasileiro
        let isAmericanFormat = false;
        if (typeof date == "string" && dateAndTime.length > 2) {
            // Se o primeiro token > 12, é definitivamente o dia (formato brasileiro DD/MM/YYYY)
            // Se o segundo token > 12, é definitivamente o dia (formato americano MM/DD/YYYY)
            let firstToken = parseInt(dateTokens[0]);
            let secondToken = parseInt(dateTokens[1]);

            if (firstToken > 12) {
                // Primeiro token > 12 significa que é o dia, então é formato brasileiro (DD/MM/YYYY)
                isAmericanFormat = false;
            } else if (secondToken > 12) {
                // Segundo token > 12 significa que é o dia, então é formato americano (MM/DD/YYYY)
                isAmericanFormat = true;
            } else if (firstToken <= 12 && secondToken <= 12) {
                // Ambos <= 12, não podemos determinar com certeza
                // Quando há AM/PM em strings, pode ser formato americano, mas assumimos brasileiro por padrão
                isAmericanFormat = false;
            }
        }
        // Se veio de Date.toLocaleString('pt-BR'), sempre é formato brasileiro (já é false por padrão)

        // Define mês e dia baseado no formato detectado
        let month, day;
        if (isAmericanFormat) {
            // Formato americano: MM/DD/YYYY
            month = dateTokens[0].length === 2 ? dateTokens[0] : "0" + dateTokens[0];
            day = dateTokens[1].length === 2 ? dateTokens[1] : "0" + dateTokens[1];
        } else {
            // Formato brasileiro: DD/MM/YYYY
            month = dateTokens[1].length === 2 ? dateTokens[1] : "0" + dateTokens[1];
            day = dateTokens[0].length === 2 ? dateTokens[0] : "0" + dateTokens[0];
        }

        let timetokens = dateAndTime[1].split(':');
        let minutes = timetokens[1].length === 2 ? timetokens[1] : "0" + timetokens[1];
        let seconds = timetokens[2].length === 2 ? timetokens[2] : "0" + timetokens[2];

        let hours = timetokens[0];

        if (dateAndTime.length > 2) {
            if (dateAndTime[2] === "PM") {
                let hoursBR = parseInt(timetokens[0]);
                if (hoursBR < 12) {
                    hoursBR += 12;
                }
                hours = hoursBR.toString();
            } else if (dateAndTime[2] === "AM") {
                let hoursBR = parseInt(timetokens[0]);
                if (hoursBR === 12) {
                    hoursBR = 0;
                }
                hours = hoursBR.toString();
            }
        }

        if (hours.length < 2) {
            hours = "0" + hours;
        }

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    },
    setDefaultDateFilters(horarioOperacional) {
        let today = new Date();
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        let dti = new Date(today.toISOString().substring(0, 10) + "T" + horarioOperacional + ":00");
        let dtf = new Date(tomorrow.toISOString().substring(0, 10) + "T" + horarioOperacional + ":00");
        dtf.setSeconds(dtf.getSeconds() - 1);

        return [dti, dtf];
    },
    /**
     * Período de `dias` dias operacionais (Configurações > hora inicial do dia de operação) até o dia
     * operacional corrente: começa na hora inicial de `dias` dias atrás e termina 1s antes da hora
     * inicial de amanhã. Antes da hora inicial, o dia operacional corrente ainda é o de ontem.
     */
    periodoDiasOperacionais(horarioOperacional, dias) {
        const [hh, mm] = String(horarioOperacional || '00:00').split(':').map(Number);
        const agora = new Date();
        const inicioDia = new Date(agora);
        inicioDia.setHours(hh || 0, mm || 0, 0, 0);
        if (inicioDia > agora) inicioDia.setDate(inicioDia.getDate() - 1);
        const dti = new Date(inicioDia);
        dti.setDate(dti.getDate() - dias);
        const dtf = new Date(inicioDia);
        dtf.setDate(dtf.getDate() + 1);
        dtf.setSeconds(dtf.getSeconds() - 1);
        return [dti, dtf];
    },
    setDefaultDateFiltersYesterday(horarioOperacional) {
        let today = new Date();
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        let dti = new Date(yesterday.toISOString().substring(0, 10) + " " + horarioOperacional + ":00");
        let dtf = new Date(today.toISOString().substring(0, 10) + " " + horarioOperacional + ":00");
        dtf.setSeconds(dtf.getSeconds() - 1);

        return [dti, dtf];
    },
    calculateReferenceDates(dti, dtf, horarioOperacional) {
        // Calcula todos os dias (apenas a data) delimitados por dti e dtf, levando em consideração que um dia começa em d no horarioOperacional e termina em d+1 no horarioOperacional - 1 minuto
        // Retorna um array de strings no formato 'YYYY-MM-DD'
        let result = [];
        // Garante que dti e dtf são objetos Date
        let start = (dti instanceof Date) ? new Date(dti) : new Date(dti);
        let end = (dtf instanceof Date) ? new Date(dtf) : new Date(dtf);

        // Extrai hora e minuto do horarioOperacional
        let [horaOp, minOp] = horarioOperacional.split(':').map(Number);

        // Calcula o primeiro dia de referência: se dti for antes do horarioOperacional, começa no dia anterior
        let current = new Date(start);
        if (
            current.getHours() < horaOp ||
            (current.getHours() === horaOp && current.getMinutes() < minOp)
        ) {
            // Antes do horário operacional, considera o dia anterior
            current.setDate(current.getDate() - 1);
        }
        // Zera hora/min/seg/ms para garantir consistência
        current.setHours(0, 0, 0, 0);

        // Calcula o último dia de referência: se dtf for depois do horarioOperacional, inclui o dia de dtf
        let last = new Date(end);
        if (
            last.getHours() > horaOp ||
            (last.getHours() === horaOp && last.getMinutes() >= minOp)
        ) {
            // Depois do horário operacional, inclui o dia de dtf
            last.setHours(0, 0, 0, 0);
        } else {
            // Antes do horário operacional, considera o dia anterior
            last.setDate(last.getDate() - 1);
            last.setHours(0, 0, 0, 0);
        }

        // Gera os dias de referência
        while (current <= last) {
            // Formata para 'YYYY-MM-DD'
            let year = current.getFullYear();
            let month = (current.getMonth() + 1).toString().padStart(2, '0');
            let day = current.getDate().toString().padStart(2, '0');
            result.push(`${year}-${month}-${day}`);
            current.setDate(current.getDate() + 1);
        }

        return result;
    }
};

module.exports = DateUtils;